import axios from "axios";
import { baseURL } from "./endPoints";
import { getSessionData } from "../sessionDetailsParser";

const config = {
  headers: { Authorization: getSessionData("token") },
};

const create = (url, data) => {
  return axios.post(`${baseURL}${url}`, data, config);
};

const get = (url) => {
  return axios.get(`${baseURL}${url}`, config);
};

const update = (url, data) => {
  return axios.put(`${baseURL}${url}`, data, config);
};

const deleteData = (url, data) => {
  const { id } = data;
  return axios.delete(`${baseURL}${url}/${id}`, config);
};

export { create, update, get, deleteData };
